/** POST — `apiV8nocache` base is already `/api/v8`. */
const AWARDS_API_PATH = "/pbis/points/awards"
const REDEMPTIONS_API_PATH = "/pbis/points/redemptions"
const CORRECTIONS_API_PATH = "/pbis/points/corrections"

export default {
  AWARDS_API_PATH,
  REDEMPTIONS_API_PATH,
  CORRECTIONS_API_PATH
}
